import type { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/react';

export const MergeFieldNodeView = ({ node }: NodeViewProps) => {
  const key = node.attrs.key as string;
  const sample = node.attrs.sample as string | null;

  return (
    <NodeViewWrapper
      as="span"
      className="inline-flex flex-col rounded bg-violet-100 px-1.5 py-0.5 text-violet-700 leading-tight dark:bg-violet-500/15 dark:text-violet-300"
      contentEditable={false}
    >
      {sample ? (
        <>
          <span className="text-xs font-semibold">{sample}</span>
          <span className="font-mono text-[9px] font-medium opacity-50">{key}</span>
        </>
      ) : (
        <span className="text-xs font-semibold">
          <span className="opacity-60">{'{'}</span>
          {key}
          <span className="opacity-60">{'}'}</span>
        </span>
      )}
    </NodeViewWrapper>
  );
};
